/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./group-selector.vue?vue&type=template&id=3f658fb3&scoped=true&"
import script from "./group-selector.vue?vue&type=script&lang=js&"
export * from "./group-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f658fb3",
  null
  
)

export default component.exports